// export const products = [
//   { id: 1, name: "Ryzen 7 5800X", price: 30000, category: "CPUs", icon: "fas fa-microchip", stock: 15, sku: "CPU-RYZEN7-5800X", image: "https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=100&h=100&fit=crop" },
//   { id: 2, name: "GeForce RTX 4070", price: 50000, category: "GPUs", icon: "fas fa-gamepad", stock: 8, sku: "GPU-RTX4070", image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" },
//   { id: 1, name: "Ryzen 7 5800X", price: 30000, category: "CPUs", icon: "fas fa-microchip", stock: 15, sku: "CPU-RYZEN7-5800X", image: "https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=100&h=100&fit=crop" },
//   { id: 2, name: "GeForce RTX 4070", price: 50000, category: "GPUs", icon: "fas fa-gamepad", stock: 8, sku: "GPU-RTX4070", image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" },
//   { id: 1, name: "Ryzen 7 5800X", price: 30000, category: "CPUs", icon: "fas fa-microchip", stock: 15, sku: "CPU-RYZEN7-5800X", image: "https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=100&h=100&fit=crop" },
//   { id: 2, name: "GeForce RTX 4070", price: 50000, category: "GPUs", icon: "fas fa-gamepad", stock: 8, sku: "GPU-RTX4070", image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" },
//   { id: 1, name: "Ryzen 7 5800X", price: 30000, category: "CPUs", icon: "fas fa-microchip", stock: 15, sku: "CPU-RYZEN7-5800X", image: "https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=100&h=100&fit=crop" },
//   { id: 2, name: "GeForce RTX 4070", price: 50000, category: "GPUs", icon: "fas fa-gamepad", stock: 8, sku: "GPU-RTX4070", image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" },
//   { id: 1, name: "Ryzen 7 5800X", price: 30000, category: "CPUs", icon: "fas fa-microchip", stock: 15, sku: "CPU-RYZEN7-5800X", image: "https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=100&h=100&fit=crop" },
//   { id: 2, name: "GeForce RTX 4070", price: 50000, category: "GPUs", icon: "fas fa-gamepad", stock: 8, sku: "GPU-RTX4070", image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" },
//   { id: 1, name: "Ryzen 7 5800X", price: 30000, category: "CPUs", icon: "fas fa-microchip", stock: 15, sku: "CPU-RYZEN7-5800X", image: "https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=100&h=100&fit=crop" },
//   { id: 2, name: "GeForce RTX 4070", price: 50000, category: "GPUs", icon: "fas fa-gamepad", stock: 8, sku: "GPU-RTX4070", image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" },
//   { id: 1, name: "Ryzen 7 5800X", price: 30000, category: "CPUs", icon: "fas fa-microchip", stock: 15, sku: "CPU-RYZEN7-5800X", image: "https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=100&h=100&fit=crop" },
//   { id: 2, name: "GeForce RTX 4070", price: 50000, category: "GPUs", icon: "fas fa-gamepad", stock: 8, sku: "GPU-RTX4070", image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" },
//   { id: 1, name: "Ryzen 7 5800X", price: 30000, category: "CPUs", icon: "fas fa-microchip", stock: 15, sku: "CPU-RYZEN7-5800X", image: "https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=100&h=100&fit=crop" },
//   { id: 2, name: "GeForce RTX 4070", price: 50000, category: "GPUs", icon: "fas fa-gamepad", stock: 8, sku: "GPU-RTX4070", image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" },
// ];

// export const products = [
//   { 
//     id: 1, 
//     name: "Ryzen 7 5800X", 
//     price: 30000, 
//     category: "CPUs", 
//     icon: "fas fa-microchip", 
//     stock: 15, 
//     sku: "CPU-RYZEN7-5800X", 
//     barcode: "1234567890123",
//     image: "https://images.unsplash.com/photo-1591405351990-4726e331f141?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 2, 
//     name: "GeForce RTX 4070", 
//     price: 50000, 
//     category: "GPUs", 
//     icon: "fas fa-gamepad", 
//     stock: 8, 
//     sku: "GPU-RTX4070", 
//     barcode: "1234567890124",
//     image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 3, 
//     name: "Corsair Vengeance 32GB", 
//     price: 12000, 
//     category: "RAM", 
//     icon: "fas fa-memory", 
//     stock: 20, 
//     sku: "RAM-CORS-32GB", 
//     image: "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 4, 
//     name: "Samsung 980 Pro 2TB", 
//     price: 22000, 
//     category: "Storage", 
//     icon: "fas fa-hdd", 
//     stock: 12, 
//     sku: "SSD-SAMSUNG-2TB", 
//     image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 5, 
//     name: "ASUS ROG Strix X570", 
//     price: 25000, 
//     category: "Motherboards", 
//     icon: "fas fa-circuit-board", 
//     stock: 10, 
//     sku: "MB-ASUS-X570", 
//     image: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 6, 
//     name: "Corsair RM850x", 
//     price: 15000, 
//     category: "PSUs", 
//     icon: "fas fa-plug", 
//     stock: 7, 
//     sku: "PSU-CORS-850W", 
//     image: "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 7, 
//     name: "NZXT H710i", 
//     price: 15000, 
//     category: "Cases", 
//     icon: "fas fa-desktop", 
//     stock: 15, 
//     sku: "CASE-NZXT-H710i", 
//     image: "https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 8, 
//     name: "Noctua NH-D15 Chromax", 
//     price: 9000, 
//     category: "Cooling", 
//     icon: "fas fa-fan", 
//     stock: 9, 
//     sku: "COOL-NOCTUA-D15C", 
//     image: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 9, 
//     name: "Logitech G Pro X", 
//     price: 12000, 
//     category: "Peripherals", 
//     icon: "fas fa-keyboard", 
//     stock: 25, 
//     sku: "KB-LOGI-GPROX", 
//     image: "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 10, 
//     name: "Razer Viper Ultimate", 
//     price: 10000, 
//     category: "Peripherals", 
//     icon: "fas fa-mouse", 
//     stock: 30, 
//     sku: "MOUSE-RAZER-VU", 
//     image: "https://images.unsplash.com/photo-1527814050087-3793815479db?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 11, 
//     name: "AMD Ryzen 9 5950X", 
//     price: 55000, 
//     category: "CPUs", 
//     icon: "fas fa-microchip", 
//     stock: 5, 
//     sku: "CPU-RYZEN9-5950X", 
//     image: "https://images.unsplash.com/photo-1591405351990-4726e331f141?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 12, 
//     name: "NVIDIA RTX 4090", 
//     price: 125000, 
//     category: "GPUs", 
//     icon: "fas fa-gamepad", 
//     stock: 3, 
//     sku: "GPU-RTX4090", 
//     image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 13, 
//     name: "G.Skill Trident Z Royal", 
//     price: 18000, 
//     category: "RAM", 
//     icon: "fas fa-memory", 
//     stock: 18, 
//     sku: "RAM-GSKILL-ROYAL", 
//     image: "https://images.unsplash.com/photo-1527814050087-3793815479db?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 14, 
//     name: "WD Black SN850X 4TB", 
//     price: 38000, 
//     category: "Storage", 
//     icon: "fas fa-hdd", 
//     stock: 8, 
//     sku: "SSD-WD-4TB", 
//     image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 15, 
//     name: "MSI MEG X670E", 
//     price: 35000, 
//     category: "Motherboards", 
//     icon: "fas fa-circuit-board", 
//     stock: 6, 
//     sku: "MB-MSI-X670E", 
//     image: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 16, 
//     name: "Seasonic Prime TX-1000", 
//     price: 28000, 
//     category: "PSUs", 
//     icon: "fas fa-plug", 
//     stock: 11, 
//     sku: "PSU-SEAS-1000W", 
//     image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 17, 
//     name: "Lian Li O11 Dynamic", 
//     price: 18000, 
//     category: "Cases", 
//     icon: "fas fa-desktop", 
//     stock: 14, 
//     sku: "CASE-LIAN-O11", 
//     image: "https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 18, 
//     name: "Corsair iCUE H150i", 
//     price: 16000, 
//     category: "Cooling", 
//     icon: "fas fa-fan", 
//     stock: 12, 
//     sku: "COOL-CORS-H150i", 
//     image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" 
//   },
//   { 
//     id: 19, 
//     name: "SteelSeries Apex Pro", 
//     price: 15000, 
//     category: "Peripherals", 
//     icon: "fas fa-keyboard", 
//     stock: 22, 
//     sku: "KB-STEEL-APEX", 
//     image: "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=300&h=300&fit=crop&auto=format" 
//   },
//   { 
//     id: 20, 
//     name: "Logitech MX Master 3", 
//     price: 9000, 
//     category: "Peripherals", 
//     icon: "fas fa-mouse", 
//     stock: 28, 
//     sku: "MOUSE-LOGI-MX3", 
//     image: "https://images.unsplash.com/photo-1527814050087-3793815479db?w=300&h=300&fit=crop&auto=format" 
//   }
// ];

// // Format number with thousand separators
// export const formatCurrency = (value) => {
//   return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// };

// // If you want to display prices without decimal places for whole numbers:
// export const formatCurrencyNoDecimals = (value) => {
//   return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// };




export const products = [
  { 
    id: 1, 
    name: "Ryzen 7 5800X", 
    price: 30000, 
    category: "CPUs", 
    subCategory: "amd", // Added sub-category
    icon: "fas fa-microchip", 
    stock: 15, 
    sku: "CPU-RYZEN7-5800X", 
    barcode: "1234567890123",
    image: "https://images.unsplash.com/photo-1591405351990-4726e331f141?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 2, 
    name: "GeForce RTX 4070", 
    price: 50000, 
    category: "GPUs", 
    subCategory: "nvidia", // Added sub-category
    icon: "fas fa-gamepad", 
    stock: 8, 
    sku: "GPU-RTX4070", 
    barcode: "2345678901234",
    image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 3, 
    name: "Corsair Vengeance 32GB", 
    price: 12000, 
    category: "Memory", 
    subCategory: "ddr4", // Added sub-category
    icon: "fas fa-memory", 
    stock: 20, 
    sku: "RAM-CORS-32GB", 
    barcode: "3456789012345",
    image: "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 4, 
    name: "Samsung 980 Pro 2TB", 
    price: 22000, 
    category: "Storage", 
    subCategory: "nvme", // Added sub-category
    icon: "fas fa-hdd", 
    stock: 12, 
    sku: "SSD-SAMSUNG-2TB", 
    barcode: "4567890123456",
    image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 5, 
    name: "ASUS ROG Strix X570", 
    price: 25000, 
    category: "Motherboards", 
    subCategory: "amd", // Added sub-category
    icon: "fas fa-circuit-board", 
    stock: 10, 
    sku: "MB-ASUS-X570", 
    barcode: "5678901234567",
    image: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 6, 
    name: "Corsair RM850x", 
    price: 15000, 
    category: "PSUs", 
    subCategory: "atx", // Added sub-category
    icon: "fas fa-plug", 
    stock: 7, 
    sku: "PSU-CORS-850W", 
    barcode: "6789012345678",
    image: "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 7, 
    name: "NZXT H710i", 
    price: 15000, 
    category: "Cases", 
    subCategory: "mid_tower", // Added sub-category
    icon: "fas fa-desktop", 
    stock: 15, 
    sku: "CASE-NZXT-H710i", 
    barcode: "7890123456789",
    image: "https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 8, 
    name: "Noctua NH-D15 Chromax", 
    price: 9000, 
    category: "Cooling", 
    subCategory: "air", // Added sub-category
    icon: "fas fa-fan", 
    stock: 9, 
    sku: "COOL-NOCTUA-D15C", 
    barcode: "8901234567890",
    image: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 9, 
    name: "Logitech G Pro X", 
    price: 12000, 
    category: "Peripherals", 
    subCategory: "keyboards", // Added sub-category
    icon: "fas fa-keyboard", 
    stock: 25, 
    sku: "KB-LOGI-GPROX", 
    barcode: "9012345678901",
    image: "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 10, 
    name: "Razer Viper Ultimate", 
    price: 10000, 
    category: "Peripherals", 
    subCategory: "mice", // Added sub-category
    icon: "fas fa-mouse", 
    stock: 30, 
    sku: "MOUSE-RAZER-VU", 
    barcode: "0123456789012",
    image: "https://images.unsplash.com/photo-1527814050087-3793815479db?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 11, 
    name: "AMD Ryzen 9 5950X", 
    price: 55000, 
    category: "CPUs", 
    subCategory: "amd", // Added sub-category
    icon: "fas fa-microchip", 
    stock: 5, 
    sku: "CPU-RYZEN9-5950X", 
    barcode: "1134567890123",
    image: "https://images.unsplash.com/photo-1591405351990-4726e331f141?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 12, 
    name: "NVIDIA RTX 4090", 
    price: 125000, 
    category: "GPUs", 
    subCategory: "nvidia", // Added sub-category
    icon: "fas fa-gamepad", 
    stock: 3, 
    sku: "GPU-RTX4090", 
    barcode: "2245678901234",
    image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 13, 
    name: "G.Skill Trident Z Royal", 
    price: 18000, 
    category: "Memory", 
    subCategory: "rgb", // Added sub-category
    icon: "fas fa-memory", 
    stock: 18, 
    sku: "RAM-GSKILL-ROYAL", 
    barcode: "3356789012345",
    image: "https://images.unsplash.com/photo-1527814050087-3793815479db?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 14, 
    name: "WD Black SN850X 4TB", 
    price: 38000, 
    category: "Storage", 
    subCategory: "nvme", // Added sub-category
    icon: "fas fa-hdd", 
    stock: 8, 
    sku: "SSD-WD-4TB", 
    barcode: "4467890123456",
    image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 15, 
    name: "MSI MEG X670E", 
    price: 35000, 
    category: "Motherboards", 
    subCategory: "amd", // Added sub-category
    icon: "fas fa-circuit-board", 
    stock: 6, 
    sku: "MB-MSI-X670E", 
    barcode: "5578901234567",
    image: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 16, 
    name: "Seasonic Prime TX-1000", 
    price: 28000, 
    category: "PSUs", 
    subCategory: "atx", // Added sub-category
    icon: "fas fa-plug", 
    stock: 11, 
    sku: "PSU-SEAS-1000W", 
    barcode: "6689012345678",
    image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 17, 
    name: "Lian Li O11 Dynamic", 
    price: 18000, 
    category: "Cases", 
    subCategory: "mid_tower", // Added sub-category
    icon: "fas fa-desktop", 
    stock: 14, 
    sku: "CASE-LIAN-O11", 
    barcode: "7790123456789",
    image: "https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 18, 
    name: "Corsair iCUE H150i", 
    price: 16000, 
    category: "Cooling", 
    subCategory: "liquid", // Added sub-category
    icon: "fas fa-fan", 
    stock: 12, 
    sku: "COOL-CORS-H150i", 
    barcode: "8801234567890",
    image: "https://images.unsplash.com/photo-1591488320449-011701bb6704?w=100&h=100&fit=crop" 
  },
  { 
    id: 19, 
    name: "SteelSeries Apex Pro", 
    price: 15000, 
    category: "Peripherals", 
    subCategory: "keyboards", // Added sub-category
    icon: "fas fa-keyboard", 
    stock: 22, 
    sku: "KB-STEEL-APEX", 
    barcode: "9912345678901",
    image: "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=300&h=300&fit=crop&auto=format" 
  },
  { 
    id: 20, 
    name: "Logitech MX Master 3", 
    price: 9000, 
    category: "Peripherals", 
    subCategory: "mice", // Added sub-category
    icon: "fas fa-mouse", 
    stock: 28, 
    sku: "MOUSE-LOGI-MX3", 
    barcode: "0023456789012",
    image: "https://images.unsplash.com/photo-1527814050087-3793815479db?w=300&h=300&fit=crop&auto=format" 
  }
];

// Format number with thousand separators
export const formatCurrency = (value) => {
  return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// If you want to display prices without decimal places for whole numbers:
export const formatCurrencyNoDecimals = (value) => {
  return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};